// removed by extract-text-webpack-plugin
module.exports = {"app":"styles__app__3vmdh","centeredApp":"styles__centeredApp__3Ztlv","classifierContainer":"styles__classifierContainer__2oeH5","imgContainer":"styles__imgContainer__1eXVI","center":"styles__center__2WhTA","info":"styles__info__1eSEn"};


//////////////////
// WEBPACK FOOTER
// ./example/src/containers/App/styles.scss
// module id = 100
// module chunks = 0